module.exports = __webpack_public_path__ + "img/288415462.35d537f6.jpg";